import { render, staticRenderFns } from "./after-sales.vue?vue&type=template&id=311f1af4&scoped=true"
import script from "./after-sales.vue?vue&type=script&lang=js"
export * from "./after-sales.vue?vue&type=script&lang=js"
import style0 from "./after-sales.vue?vue&type=style&index=0&id=311f1af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f1af4",
  null
  
)

export default component.exports